var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9166 15.0832L25.0166 27.6499C24.0833 30.6332 19.9 30.6832 18.9166 27.7166L17.75 24.2666C17.4333 23.3166 16.6833 22.5499 15.7333 22.2499L12.2666 21.0832C9.31662 20.0999 9.36662 15.8832 12.35 14.9832L24.9166 11.0666C27.3833 10.3166 29.7 12.6332 28.9166 15.0832Z",
    stroke: "#070304",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 36.6666H25.0002C33.3335 36.6666 36.6668 33.3333 36.6668 24.9999V14.9999C36.6668 6.66659 33.3335 3.33325 25.0002 3.33325H15.0002C6.66683 3.33325 3.3335 6.66659 3.3335 14.9999V24.9999C3.3335 33.3333 6.66683 36.6666 15.0002 36.6666Z",
    stroke: "#070304",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrips);
export default __webpack_public_path__ + "static/media/trips.328df196577f6d932618b9f2e6c27c57.svg";
export { ForwardRef as ReactComponent };